export enum DocumentTypeEnum {
  cni = "CNI",
  passport = "PASSPORT",
  trade_registry = "TRADE_REGISTRY",
  tax_payer_ard = "TAXPAYER_CARD",
  id_bank_account = "ID_BANK_ACCOUNT",
}

export interface DocumentTypeAttributes {
  code: DocumentTypeEnum;
}
